<template>
  <article class="function-card">
    <div class="function-img-wrapper" :class="{'office-wrapper': img === '/static/img/office.ac7d282.png'}">
      <img class="function-img" :src='img' :alt='name'>
    </div>
    <div class="function-content-wrapper">
      <h3 class="name">{{name}}</h3>
      <p class="description">{{description}}</p>
    </div>
  </article>
</template>

<script>
export default {
  name: 'FunctionCard',
  props: {
    img: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.function-card {
  box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
  border-radius: 6px;
  padding: 24px;
  width: 304px;
  text-align: center;
  margin: 0 16px 32px;
  background-color: #fefefe;
}
.function-img-wrapper {
  width: 96px;
  margin:auto;
}
.function-img {
  width: 100%;
}
.function-content-wrapper {
  .name {
    margin-top: 16px;
  }
  .description {
    text-align: left;
    margin-top: 16px;
    font-size: 14px;
    line-height: 2;
    word-break: break-word;
  }
}
@media screen and (max-width: 480px) {
  .function-content-wrapper {
    .description {
      font-size: 16px;
      line-height: 1.5;
    }
  }
}
// 正式リリース後消す
.office-wrapper {
  width: 128px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/FunctionCard.vue